import React, { useState } from "react";
import Edit from "../assets/images/edit_blue.png";
import Delete from "../assets/images/delete_red.png";
import { useLocation, useNavigate } from "react-router-dom";
import { ShareModal } from "./ShareModal";
import { ConfirmModal } from "./ConfirmModal";
import {
  areaDelete,
  bulkAreaDelete,
  bulkZoneDelete,
  zoneDelete,
  zoneDetail,
} from "../utils/apiServices";
import { ErrorModal, SuccessModal, WarningModal } from "./FormComponents";
import { AuthChecker } from "../atomicComponents";

import { AUTH_CODE, path_Operation } from "../constants/constVariables";
import { useAuthorizationContext } from "../providers/AuthorizationHandler/AuthorizationHandler";
import FormModal from "./FormComponents/FormModal";
import { dateFormat, postUsageAnalyticsCall } from "../constants/Utils";
import { dateFieldHeader } from "../constants/constVariables";

export default function SmallCard(props) {
  const { user } = useAuthorizationContext();
  const navigate = useNavigate();
  const [isModalOpen, setModalIsOpen] = useState(false);
  const [flag, setFlag] = useState(true);
  const [errorMessage, seterrorMessage] = useState("");
  const [isErrorModalOpen, setErrorModalIsOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [displayModal, setDisplayModal] = useState(false);
  const location = useLocation();

  const toggleModal = (e) => {
    setFlag(false);
    setErrorModalIsOpen(!isErrorModalOpen);
  };

  const successModal = (e) => {
    setFlag(false);
    setDisplayModal(!displayModal);
    window.location.reload();
  };

  const confirmToggleModal = (e) => {
    setFlag(false);
    setModalIsOpen(!isModalOpen);
  };

  const deleteData = (e) => {
    e.stopPropagation();
    setFlag(false);
    confirmToggleModal();
  };

  const editData = async (e) => {
    e.stopPropagation();
    if (window.location.pathname == "/area-master") {
      navigate(props.editlink, { state: { edit: true, data: props.data } });
    } else if (window.location.pathname == "/zone-master") {
      const response = await zoneDetail(props.data.zone_id);
      navigate(props.editlink, {
        state: { edit: true, data: response.data.data[0] },
      });
    }
  };

  const confirmDelete = async (e) => {
    setFlag(false);
    if (window.location.pathname == "/area-master") {
      // console.log("area delete data", props.data);
      var deleteJsonpayload = {};
      deleteJsonpayload = { id: [props.data.area_id], updated_by: user.name, updated_by_id: user.userID };
      const response = await bulkAreaDelete(deleteJsonpayload)
        .then((response) => {
          confirmToggleModal();
          setTitle("Area deleted successfully");
          setDisplayModal(true);
          // console.log("fdffdfd = ", location?.pathname)
          const a = path_Operation?.filter((d, i) => {
            return d?.name == "delete-area"
          })
          // console.log("A = ", a[0]?.operation)
          postUsageAnalyticsCall(user?.name, user?.userID, "delete-area", new Date(), a[0]?.operation ? a[0]?.operation : 'view', 0)
        })
        .catch((error) => {
          var errorMessagePayload = {
            totalData: error.response.data.total_count,
            failedData: error.response.data.fail_to_delete_count,
            errorMessageData: []
          };
          error.response.data.data.forEach((element) => {
            errorMessagePayload.errorMessageData.push(element);
            // console.log(element);
          });
          setTitle(errorMessagePayload);
          setErrorModalIsOpen(true);
        });
    } else if (window.location.pathname == "/zone-master") {
      var deleteJsonpayload = {};
      deleteJsonpayload = { id: [props.data.zone_id], updated_by: user.name, updated_by_id: user.userID };
      const response = await bulkZoneDelete(deleteJsonpayload)
        .then((response) => {
          confirmToggleModal();
          setTitle("Zone deleted successfully");
          setDisplayModal(true);
          // console.log("fdffdfd = ", location?.pathname)
          const a = path_Operation?.filter((d, i) => {
            return d?.name == "delete-zone"
          })
          // console.log("A = ", a[0]?.operation)
          postUsageAnalyticsCall(user?.name, user?.userID, "delete-zone", new Date(), a[0]?.operation ? a[0]?.operation : 'view', 0)
        })
        .catch((error) => {
          var errorMessagePayload = {
            totalData: error.response.data.total_count,
            failedData: error.response.data.fail_to_delete_count,
            errorMessageData: []
          };
          error.response.data.data.forEach((element) => {
            errorMessagePayload.errorMessageData.push(element);
            // console.log(element);
          });
          setTitle(errorMessagePayload);
          setErrorModalIsOpen(true);
        });
    }
  };

  const zoneDetails = (e) => {
    e.stopPropagation();
    // console.log(flag);
    if (flag) navigate(props.link, { state: { data: props.data } });
  };

  // console.log("PROPSSSSSSS", props);

  return (
    <>
      {props.data != undefined ? (
        <div className="small-card" onClick={zoneDetails}>
          <div className="small-card-container">
            <div className="small-card-header mediumFont">
              <div>{props.header}</div>
              {props.icon ? (
                <div style={{ fontWeight: 0, display: "flex", gap: "1rem" }}>
                  <AuthChecker operation={props?.authEdit ? AUTH_CODE?.EDIT : null}>
                    {(isAuthorized) => (
                      <img
                        src={Edit}
                        onClick={editData}
                        style={{
                          cursor: "pointer",
                          display: !isAuthorized ? "none" : "block",
                        }}
                        className="small-card-header-icon"
                        alt="edit"
                      />
                    )}
                  </AuthChecker>
                  <AuthChecker operation={props?.authDelete ? AUTH_CODE?.DELETE : null}>
                    {(isAuthorized) => (
                      <img
                        src={Delete}
                        onClick={deleteData}
                        style={{ cursor: "pointer", display: !isAuthorized ? "none" : "block", }}
                        className="small-card-header-icon"
                        alt="delete"
                      />
                    )}
                  </AuthChecker>
                  {isModalOpen && (
                    <WarningModal
                      open={isModalOpen}
                      handleClose={() => confirmToggleModal()}
                      confirmDelete={() => confirmDelete()}
                    />
                  )}
                  {isErrorModalOpen && (
                    <FormModal open={isErrorModalOpen} handleClose={() => toggleModal()} title={title} />
                  )}
                  {displayModal && (
                    <SuccessModal
                      open={displayModal}
                      handleClose={() => successModal()}
                      title={title}
                    />
                  )}
                </div>
              ) : (
                <div
                  className="small-card-header-left"
                  style={{ fontWeight: 0 }}
                >
                  {props.data["vc_number"]}
                </div>
              )}
            </div>
            <div className="small-card-tabs-container">
              {props.subheader.map((values) => {
                // console.log("values = ", values, dateFieldHeader.includes(values.vars))
                return (
                  <div className="small-card-tabs">
                    <span className="small-card-tabs-heading smallFont">
                      {values.name}
                    </span>
                    <span className="small-card-tabs-data regularFont">
                      {props.data[values.vars] ? dateFieldHeader.includes(values.vars) ? dateFormat(props.data[values.vars]) : props.data[values.vars] : "-"}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
